
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./InsuranceReport.css'],
  selector: 'InsuranceReport',
  templateUrl: './InsuranceReport.html',
})
export class InsuranceReportComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "InsuranceReport");
    }
}
